import {Pill} from '@wandb/components';
import React, {useEffect, useLayoutEffect} from 'react';

import {envIsServerDeployment} from '../../../config';
import {
  IngestionHealthStatus,
  RampIdType,
  useWorkspaceIngestionHealthQuery,
} from '../../../generated/graphql';
import {useViewer} from '../../../state/viewer/hooks';
import {propagateErrorsContext} from '../../../util/errors';
import {useUserRampFlag} from '../../../util/useRampFlag';
import {
  claimViewOnceAction,
  useViewOnceActionsStore,
} from '../../../util/viewOnceActions';

export const IngestionDelayedPill = () => {
  const enabled = useUserRampFlag(
    'ingestion_health_pill_user',
    RampIdType.UserId
  );
  const viewer = useViewer();
  if (!enabled || !viewer || envIsServerDeployment) {
    return null;
  }
  return <IngestionDelayedPillContent />;
};

const IngestionDelayedPillContent = () => {
  const {data, error, loading} = useWorkspaceIngestionHealthQuery({
    fetchPolicy: 'network-only',
    context: propagateErrorsContext(),
  });
  const health = data?.serverInfo?.ingestionHealth;

  if (loading || error || health?.status !== IngestionHealthStatus.Delayed) {
    return null;
  }
  return <VisibleIngestionDelayedPill />;
};

const VisibleIngestionDelayedPill = () => {
  useLayoutEffect(() => {
    trackDelayEventOncePerView('Ingestion delay shown');
    return useViewOnceActionsStore.subscribe((state, previous) => {
      if (
        state.recorded !== previous.recorded &&
        Object.keys(state.recorded).length === 0
      ) {
        trackDelayEventOncePerView('Ingestion delay shown');
      }
    });
  }, []);

  return (
    <Pill
      tooltip={{children: <IngestionDelayedTooltip />, placement: 'bottom'}}
      icon="warning"
      color="sienna"
      textValue="Ingestion delayed"
    />
  );
};

const IngestionDelayedTooltip = () => {
  useEffect(() => {
    trackDelayEventOncePerView('Ingestion delay tooltip opened');
  }, []);

  return (
    <span>
      Summary metrics and run updates are taking longer than usual to appear.
    </span>
  );
};

function trackDelayEventOncePerView(
  name: 'Ingestion delay shown' | 'Ingestion delay tooltip opened'
) {
  if (window.analytics && claimViewOnceAction(name)) {
    window.analytics.track(name);
  }
}
